import { FC, memo } from 'react'

import { Text, Button } from '@cash-me/react-components'
import NextImage from "next/image"

import { Infos, Section } from 'components/general-styles'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { GuaranteeProps } from './guarantee.model'
import * as S from './styles'

const Guarantee: FC<GuaranteeProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <Section $bg="medium">
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.ImageWrapper>
            <S.Image>
              <NextImage
                src='/images/construction-companies/guarantee-builders.png?updated=230508'
                alt="Cadeira azul com mesinha e vaso de planta"
                width="475"
                height="552"
                quality={90}
                priority
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto"
                }} />
            </S.Image>
          </S.ImageWrapper>
        </Col>
        <Col col={{ desktop: 5 }} start={{ tablet: 2, desktop: 7 }}>
          <Infos>
            <Text as="h2" size="heading3" weight="medium">
              Como solicitar {' '}
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
                Financiamento para Construção?
              </Text>
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              O Financiamento para Construção funciona como o crédito oferecido para te estimular a construir 
              uma nova propriedade.
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Além disso, ele pode ser utilizado em diferentes fases da sua obra, como na aquisição do terreno 
              ou na contratação dos funcionários, por exemplo.
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              A partir do seu projeto, você consegue a liberação de crédito para iniciar ou continuar a sua 
              construção, e pode alcançar valores de até 50% do valor total de avaliação do imóvel finalizado.
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Ah, e nessa modalidade, você recebe o crédito em parcelas de acordo com a evolução da obra. 
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Você também pode utilizar o dinheiro para a construção de casas dentro e fora de 
              condomínios, em terrenos quitados ou com saldo devedor*, bem como para imóveis comerciais*.
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Esse tipo de financiamento é indicado para pessoas físicas ou jurídicas que desejam impulsionar sua 
              obra. Aproveite!
            </Text>
            <Text className="disclaimer" color="var(--colors-neutral-text-weak)">
              * sujeitos à análise
            </Text>
            <Button
              size="lg"
              onClick={onClick}
              {...(isTablet ? { variants: 'default', iconName: 'arrowRight' } : { variants: 'text-only' })}
            >
              Simular agora
            </Button>
          </Infos>
        </Col>
      </Grid>
    </Section>
  );
})

Guarantee.displayName = 'Guarantee'

export default Guarantee
